<template>
    <div id="login-tpa-app">
        <svgIcon icon-holder-class="nexon-logo" icon-id="nexon-logo" />
        <div v-if="isApp">
            <div v-if="!isTimeout">
                <img src="@/images/icons/icon-browser.png" />
                <div class="title">{{ $t('login-tpa-app.app.normal.title') }}</div>
                <div class="desc">{{ $t('login-tpa-app.app.normal.desc') }}</div>
            </div>
            <div v-else>
                <img src="@/images/icons/icon-timeout.png" />
                <div class="title">{{ $t('login-tpa-app.app.timeout.title') }}</div>
                <div class="desc">{{ $t('login-tpa-app.app.timeout.title') }}</div>
            </div>

            <div class="button">
                <FormButton
                    type="submit"
                    :btn-primary="true"
                    :button-click="cancel"
                    :label="$t(isTimeout ? 'login-tpa-app.app.timeout.button' : 'cancel')"
                />
            </div>
        </div>
        <div v-else>
            <img src="@/images/icons/icon-almostdone.png" />
            <div class="title">{{ $t('login-tpa-app.web.title') }}</div>
            <div class="desc">{{ $t('login-tpa-app.web.desc') }}</div>
        </div>
    </div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import { FormButton } from '@arena/toolkit';
import launcherAPI from '@/modules/launcher';

const sleep = function(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export default {
    name: 'LoginTpaApp',
    components: {
        svgIcon,
        FormButton,
    },
    metaInfo() {
        return {
            titleTemplate: `%s | ${this.$t('login.login')}`,
        };
    },
    props: {
        socialProvider: {
            type: String,
            default: '',
        },
        clientCode: {
            type: String,
            default: '',
        },
        callbackUrl: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            retry: 0,
        };
    },
    computed: {
        isApp() {
            return launcherAPI.isAppMode();
        },
        tpaType() {
            return this.capitalize(this.socialProvider);
        },
        isTimeout() {
            return this.retry >= 60;
        },
    },
    async mounted() {
        if (this.isApp) {
            // steam connector
            // ssoRequired only for account linking from setting page in launcher (it will not impact for launcher login because second parameter will be ignored)
            launcherAPI.openExternal(this.url, true);
            await sleep(3000); // initial delay
            this.checkApi();
        } else if (this.callbackUrl) {
            await this.storeApi();
            window.dataLayer.push({
                event: 'TPA External Browser Resolution',
                TPAResolution: 'Automatic',
                tpaType: this.tpaType,
            });
        }
    },
    destroyed() {
        this.retry = 60;
    },
    methods: {
        capitalize(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // web
        async storeApi() {
            try {
                await this.$accountAPI.post('/no-auth/login/tpa/callback-url', {
                    clientCode: this.clientCode,
                    callbackUrl: this.callbackUrl,
                });
            } catch (e) {
                if (this.retry < 3) {
                    this.retry += 1;
                    await sleep(1000);
                    return await this.storeApi();
                }
            }
        },
        // launcher
        async checkApi() {
            if (!this.clientCode || this.retry >= 60) {
                return;
            }
            try {
                const data = await this.$accountAPI.get('/no-auth/login/tpa/callback-url', {
                    params: { clientCode: this.clientCode },
                });
                // launcher
                if (data.callbackUrl.indexOf('/login/callback') === -1) {
                    window.parent.postMessage('window.focus', '*');
                }
                // steam connector
                if (window.requestToMain) {
                    window.requestToMain('broadcast', { window: 'focus' });
                }
                window.location = `/account${data.callbackUrl}`;
            } catch (e) {
                await sleep(2000);
                this.retry += 1;
                // console.log('retry', this.retry);
                this.checkApi();
            }
        },
        cancel() {
            dataLayer.push({
                event: this.isTimeout ? 'TPA Timeout Back Click' : 'Cancel TPA Authentication',
                tpaType: this.tpaType,
            });
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="scss">
#login-tpa-app {
    text-align: center;
    transition: all 1s;
    .nexon-logo {
        width: 120px;
        height: 20px;
        margin-top: 100px;
    }
    img {
        margin: 50px 0;
    }
    .title {
        color: #ffffff;
        font-family: 'KlavikaNX-Light';
        font-size: 24px;
        padding-bottom: 25px;
    }
    .desc {
        color: rgba(255, 255, 255, 0.5);
        font-family: Arial, Helvetica, sans-serif;
        font-size: 16px;
    }
    .button {
        max-width: 320px;
        margin: 50px auto;
    }
}
</style>
